import React, { useState } from "react";
import { useProgress } from "../../context/ProgressContext";
import { useAuth } from "../../context/AuthContext";

const SectionFooter = ({ gradeId, gradeNumber, sectionId, sections, onSectionChange }) => {
  const { isSectionComplete, toggleSectionComplete } = useProgress();
  const { user } = useAuth();
  const [showWarning, setShowWarning] = useState(false);

  const isComplete = isSectionComplete(gradeId, sectionId);
  const isLoggedIn = user && !user.isGuest;

  // Find current section index and next section
  const currentIndex = sections.findIndex(s => s.id === sectionId);
  const nextSection = currentIndex < sections.length - 1 ? sections[currentIndex + 1] : null;

  const handleMarkComplete = () => {
    toggleSectionComplete(gradeId, sectionId);
    // Show warning if user is not logged in and marking as complete
    if (!isLoggedIn && !isComplete) {
      setShowWarning(true);
      // Auto-hide warning after 5 seconds
      setTimeout(() => setShowWarning(false), 5000);
    }
  };

  const handleNextSection = () => {
    if (nextSection && onSectionChange) {
      onSectionChange(nextSection.id);
      // Scroll to top of page
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="section-footer">
      {showWarning && (
        <div className="progress-warning">
          You're not logged in. Your progress will only be saved on this device. Log in to save your progress across all devices!
          <button className="warning-close" onClick={() => setShowWarning(false)}>×</button>
        </div>
      )}

      <div className="section-footer-buttons">
        <button
          className={`section-complete-btn ${isComplete ? 'completed' : ''}`}
          onClick={handleMarkComplete}
        >
          {isComplete ? (
            <>
              <span className="check-icon">✓</span>
              Completed - Click to Undo
            </>
          ) : (
            <>
              <span className="check-icon empty">○</span>
              Mark as Complete
            </>
          )}
        </button>

        {nextSection && (
          <button
            className="next-section-btn"
            onClick={handleNextSection}
          >
            Next: {nextSection.label}
            <span className="arrow-icon">→</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default SectionFooter;
